export function measureTextPxWidth(
  text: string,
  fontSize: number = 16,
  tagName = 'span'
) {
  const template = document.createElement(tagName);

  const measurer = template.cloneNode() as HTMLElement;
  measurer.style.setProperty('all', 'revert', 'important');
  measurer.style.setProperty('position', 'position', 'important');
  measurer.style.setProperty('visibility', 'hidden', 'important');
  measurer.style.setProperty('width', 'max-content', 'important');
  measurer.style.setProperty('fontSize', fontSize + 'px', 'important');
  measurer.innerText = text;

  document.body.appendChild(measurer);
  const { width } = measurer.getBoundingClientRect();
  document.body.removeChild(measurer);
  return width;
}
